import React from 'react';
import { 
  Typography, 
  Paper, 
  Button 
} from '@mui/material';
import { PlaylistAdd as PlaylistAddIcon, MusicNote as MusicNoteIcon } from '@mui/icons-material';

interface NoPlaylistsProps {
  onCreatePlaylist: () => void;
}

const NoPlaylists: React.FC<NoPlaylistsProps> = ({ onCreatePlaylist }) => {
  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <MusicNoteIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        No Playlists Found
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        You don't have any playlists yet. Create one to get started!
      </Typography>
      <Button 
        variant="contained" 
        startIcon={<PlaylistAddIcon />}
        onClick={onCreatePlaylist}
      >
        Create Playlist
      </Button>
    </Paper>
  );
};

export default NoPlaylists;
